module.exports = __webpack_public_path__ + "img/1523003927.f64bc9df.jpg";